import { useState } from "react";
import { toast } from "sonner";
import { ShieldCheck } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";
import { addDays, todayTR } from "@/lib/helpers";

export function CleanupDialog({ onDone }) {
  const [open, setOpen] = useState(false);
  const [before, setBefore] = useState(addDays(todayTR(), -180));
  const run = async (action) => {
    const label = action === "delete" ? "silinecek" : "anonimleştirilecek";
    if (!window.confirm(`${before} tarihinden önceki tüm talepler ${label}. Bu işlem geri alınamaz. Emin misiniz?`)) return;
    try {
      const { data } = await api.post("/admin/appointments/cleanup", { before, action });
      toast.success(`${data.count} talep ${action === "delete" ? "silindi" : "anonimleştirildi"}`);
      setOpen(false);
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button className="inline-flex items-center gap-2 rounded-full bg-white border border-bej px-4 py-2 text-sm font-bold text-navy hover:bg-bej-light" data-testid="kvkk-cleanup-btn">
          <ShieldCheck className="w-4 h-4" /> KVKK temizliği
        </button>
      </DialogTrigger>
      <DialogContent className="rounded-3xl" data-testid="kvkk-cleanup-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-xl font-black text-navy">Eski talepleri temizle</DialogTitle>
          <DialogDescription>Seçilen tarihten önceki randevu talepleri anonimleştirilir (istatistik kalır, kişisel veri silinir) veya tamamen silinir.</DialogDescription>
        </DialogHeader>
        <label className="text-sm font-bold text-navy">Bu tarihten önceki talepler</label>
        <Input type="date" value={before} onChange={(e) => setBefore(e.target.value)} className="rounded-xl" data-testid="cleanup-date-input" />
        <div className="flex flex-wrap gap-2 pt-2">
          <button onClick={() => run("anonymize")} className="rounded-full bg-navy px-5 py-2.5 text-sm font-bold text-white" data-testid="cleanup-anonymize-btn">Anonimleştir</button>
          <button onClick={() => run("delete")} className="rounded-full bg-rose-600 px-5 py-2.5 text-sm font-bold text-white" data-testid="cleanup-delete-btn">Tamamen sil</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
